module.exports = __webpack_public_path__ + "static/media/gasSymbology.686a2e93.svg";